import { pocClient as poc, pocService } from "../pocConfig";
import projectConfig from "@projectConfig";

export const getAllTablesList = () => {
   return poc.get("/queries/lists");
};

export const getListV3 = (listId, page, pageSize, filters = {}) => {
   const hasFilters = filters && Object.keys(filters).length > 0;
   const method = hasFilters ? "POST" : "GET";
   const data = hasFilters ? { parameters: filters } : undefined;

   return poc({
      method,
      url: `/lists/queries/data/${listId}/page/${page}/size/${pageSize}`,
      data,
   });
};

export const getListV3WithFilter = async (
   listId,
   page,
   pageSize,
   activeFilter,
   type = "profile",
) => {
   if (type === "profile") {
      return poc.get(
         `/lists/queries/data/${listId}/profile/${activeFilter}/page/${page}/size/${pageSize}`,
      );
   } else {
      return poc.post(
         `/lists/queries/${listId}/groups/${activeFilter}/data/page/${page}/size/${pageSize}`,
      );
   }
};

export const getListV3Commands = () => {
   return poc.get("/commands/65f1c68c74bf671e548db9be");
};

export const postListV3Commands = (formId, fieldIdsAndValuesObject, listName) => {
   return poc.post("/lists/commands", {
      formId,
      name: listName,
      parameters: fieldIdsAndValuesObject,
   });
};

export const editListV3Commands = (listId, formId, name, parameters) => {
   return poc.put(`/lists/commands/${listId}`, {
      formId,
      name,
      parameters,
   });
};

export const runListV2Action = (listId, actionType, dataId) => {
   return poc.post("/lists/commands/actions", {
      actionName: actionType,
      listId,
      args: { dataId },
   });
};

export const deleteFormStructure = (formId) => {
   return poc.delete(`/commands/${formId}`);
};

export const proQLtest = () => {
   return poc.post("/data/queries", {
      type: "maps.Points",
      properties: { type: "testType" },
      page: 0,
      size: 30,
   });
};

export const addListFilter = async (listId, filter) => {
   return poc.post(`/lists/commands/${listId}/profiles`, {
      ...filter,
   });
};

export const deleteFilter = async (listId, id) => {
   return poc.delete(`/lists/commands/${listId}/profiles/${id}`);
};

export const duplicateFilter = async (listId, id) => {
   return poc.post(`/lists/commands/${listId}/profiles/${id}/copy`);
};

export const editListFilter = async (listId, filter) => {
   return poc.put(`/lists/commands/${listId}/profiles/${filter?.id}`, {
      ...filter,
   });
};

export const getListFilters = async (listId) => {
   return poc.get(`/lists/queries/${listId}/profiles`);
};

export const addGroup = async (listId, data, isEmptyGroup = false, combine = true) => {
   return poc.post(`/lists/commands/${listId}/groups?empty=${isEmptyGroup}&combine=${combine}`, {
      ...data,
   });
};

export const getDataForSelectFilters = async (url) => {
   return poc.get(url);
};

export const deleteGroup = async (listId, id) => {
   return poc.delete(`/lists/commands/${listId}/groups/${id}`);
};

export const duplicateGroup = async (listId, id) => {
   return poc.post(`/lists/commands/${listId}/groups/${id}/copy`);
};

export const modifyGroup = async (listId, filter) => {
   return poc.patch(`/lists/commands/${listId}/groups/${filter?.id}`, {
      active: filter.active,
   });
};

export const editListGroup = async (listId, filter) => {
   return poc.put(`/lists/commands/${listId}/groups/${filter?.id}`, {
      ...filter,
   });
};

export const addObjectToGroup = async (listId, groupId, data) => {
   return poc.post(`/lists/commands/${listId}/groups/${groupId}/records`, data);
};

export const getProfiles = async (listId) => {
   return poc.get(`/lists/queries/${listId}/profiles`);
};

export const APIActions = async (url, data = undefined) => {
   return poc.post(url, data, {
      responseType: "arraybuffer",
      validateStatus: () => true,
   });
};
